import { t } from '@lingui/macro';
import { useLocale } from './useLocale';

type EmailType = {
  email: string;
};

export const useEmail = (
  isAccountant?: boolean,
  companyName?: string | null,
): EmailType => {
  const { isDE } = useLocale();
  const email =
    companyName === 'Commerzbank' && isDE
      ? 'cb@iwoca.de'
      : isAccountant
        ? t`accountants@iwoca.co.uk`
        : t`brokers@iwoca.co.uk`;

  return {
    email,
  };
};
